import LegalPage, { Section } from "@/components/LegalPage";

const Privacy = () => (
  <LegalPage title="Privacy Policy" updated="Last updated: 2026" testid="privacy-page">
    <Section title="1. Introduction">
      <p>
        BR Hospitality (&ldquo;BR Hospitality&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;) is a
        boutique hospitality recruitment and advisory firm operating across Europe, the Middle
        East and Asia. This Privacy Policy explains how we collect, use, store and protect
        personal information submitted through br-hospitality.com.
      </p>
    </Section>

    <Section title="2. Information We Collect">
      <p>When you submit an employer enquiry, we may collect your name, company, position, email address, phone number, property or restaurant name, location and the details of your message.</p>
      <p>When you submit a candidate profile, we may collect your full name, email address, phone or WhatsApp number, current location, nationality, current and desired position, years of experience, LinkedIn profile, curriculum vitae (CV) and any message you choose to include.</p>
    </Section>

    <Section title="3. How We Use Your Information">
      <p>We use personal information solely to respond to enquiries, to evaluate candidate profiles for relevant hospitality recruitment opportunities, and to communicate with you about our services. We do not use your information for unrelated marketing purposes.</p>
    </Section>

    <Section title="4. Confidentiality of Candidate Information">
      <p>
        Candidate information is handled confidentially and used only for relevant hospitality
        recruitment opportunities. Candidate profiles are shared with prospective employers only
        where there is a genuine, relevant opportunity, and we take care to approach such sharing
        with discretion.
      </p>
    </Section>

    <Section title="5. Data Sharing">
      <p>
        We do not sell, rent or trade personal information. Information may be shared with client
        hotels, restaurants and hospitality groups strictly for recruitment purposes, and with
        service providers who assist in operating our website and communications, subject to
        appropriate safeguards.
      </p>
    </Section>

    <Section title="6. Data Retention">
      <p>
        We retain personal information only for as long as necessary to fulfil recruitment and
        advisory purposes, or as required by applicable law. You may request deletion of your
        information at any time.
      </p>
    </Section>

    <Section title="7. Data Security">
      <p>
        We apply reasonable technical and organisational measures to protect personal information
        against unauthorised access, loss or misuse. However, no method of transmission over the
        internet can be guaranteed to be completely secure.
      </p>
    </Section>

    <Section title="8. Your Rights">
      <p>
        Depending on your location, you may have the right to access, correct, restrict or delete
        the personal information we hold about you, and to object to its processing. To exercise
        any of these rights, contact us at{" "}
        <a href="mailto:info@br-hospitality.com" className="text-bronze link-underline">
          info@br-hospitality.com
        </a>
        .
      </p>
    </Section>

    <Section title="9. Cookies">
      <p>
        This website does not use advertising or tracking cookies. Only technically necessary
        storage may be used to ensure the website functions correctly.
      </p>
    </Section>

    <Section title="10. International Operations">
      <p>
        As we operate across Europe, the Middle East and Asia, your information may be processed
        in jurisdictions other than your own. Where this occurs, we take reasonable steps to
        ensure appropriate protection of your data.
      </p>
    </Section>

    <Section title="11. Changes to This Policy">
      <p>
        We may update this Privacy Policy from time to time. The current version will always be
        published on this page.
      </p>
    </Section>

    <Section title="12. Contact">
      <p>
        BR Hospitality — Recruitment &amp; Advisory
        <br />
        Email:{" "}
        <a href="mailto:info@br-hospitality.com" className="text-bronze link-underline">
          info@br-hospitality.com
        </a>
        <br />
        Phone: +63 995 354 4784
        <br />
        Website: br-hospitality.com
      </p>
    </Section>
  </LegalPage>
);

export default Privacy;
